import React from 'react';
import ReactDOM from 'react-dom/client';
import '../src/styles/animations.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';

if (process.env.REACT_APP_BASE_URL?.includes('sandbox')) {
  const meta = document.createElement('meta');
  meta.name = 'robots';
  meta.content = 'noindex, nofollow';
  document.head.appendChild(meta);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
